import * as Yup from "yup";

export const notificationsScheduleSchema = Yup.object().shape({
  event: Yup.string()
    .required("O evento é obrigatório")
    .oneOf(["scheduled", "finalized", "reminder"]),
  target: Yup.string()
    .required("O destino é obrigatório")
    .oneOf(["client", "professional", "both"]),
  days_before: Yup.number()
    .transform((v) =>
      v === "" || v === null || v === undefined ? 0 : Number(v),
    )
    .min(0, "Dias antes deve ser >= 0"),
  title: Yup.string().nullable(),
  message: Yup.string()
    .required("Mensagem é obrigatória")
    .max(500, "Mensagem deve ter no máximo 500 caracteres"),
  active: Yup.boolean().required(),
});
